<template>
    <form>
        <form-alert />

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="name">
                        Name
                    </label>
                    <form-input
                        v-model="mutableData.name"
                        name="name"
                        data-vv-as="Name"
                    />
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label for="name_sanatised">
                        Sanitised Name
                    </label>
                    <form-input
                        v-model="mutableData.name_sanatised"
                        name="name_sanatised"
                        data-vv-as="Sanitised Name"
                    />
                </div>
            </div>
        </div>

        <div class="form-group">
            <label for="slug">
                Slug
            </label>
            <form-input
                v-model="mutableData.slug"
                name="slug"
                data-vv-as="Slug"
            />
        </div>

        <div class="form-group">
            <label for="is_archived">
                Status
            </label>
            <form-select
                v-model="mutableData.is_archived"
                name="is_archived"
                :options="{ 0: 'Active', 1: 'Archived' }"
                data-vv-as="Status"
            />
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="is_featured">
                        Featured on homepage?
                    </label>
                    <form-select
                        v-model="mutableData.is_featured"
                        name="is_featured"
                        :options="{ 0: 'No', 1: 'Yes' }"
                        data-vv-as="Featured"
                    />
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label for="sequence_number">
                        Sequence Number
                    </label>
                    <form-input
                        v-model="mutableData.sequence_number"
                        name="sequence_number"
                        data-vv-as="Sequence Number"
                    />
                </div>
            </div>
        </div>

        <form-alert />

        <button
            :disabled="isSending"
            class="btn btn-success btn-block"
            @click.prevent="submitForm()"
        >
            Save
        </button>
    </form>
</template>

<script>
import Form from "../mixins/Form.js";

export default {
  mixins: [
    Form,
  ],
};
</script>
